import 'css-chunksrc/client/pages/projectPage/kanbanPage/loader/column/styles.scss';export default {
  "column": "_column_1nj5a_1",
  "heading": "_heading_1nj5a_10",
  "icon": "_icon_1nj5a_22",
  "title": "_title_1nj5a_27",
  "tasks": "_tasks_1nj5a_33"
};